module.exports = {"headline":"Get in touch to learn more or see a demo!","button1":{"label":"Email us","to":"mailto:contact@graasp.org"}}